import { useQuery } from '@tanstack/react-query';

import ReconciliationsApiHandler from 'app/services/reconciliationsApiHandler';

import {
  ListPage,
  UnverifiableAggregate,
  UnverifiableAggregatesRequest,
} from 'app/types/reconciliations';

export const UNVERIFIABLE_AGGREGATES_QUERY_KEY = 'fetchUnverifiableAggregates';

/** Lists the aggregates a reconciliation run could not verify, and why. */
const useFetchUnverifiableAggregates = (
  { id, companyId, page, size }: UnverifiableAggregatesRequest,
  enabled = true
) =>
  useQuery<ListPage<UnverifiableAggregate>, Error>(
    [UNVERIFIABLE_AGGREGATES_QUERY_KEY, id, companyId, page, size],
    () => ReconciliationsApiHandler.listUnverifiableAggregates({ id, companyId, page, size }),
    { enabled: enabled && !!id, keepPreviousData: true }
  );

export default useFetchUnverifiableAggregates;
